import React, { useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import BreadcrumbSection from "components/BreadcrumbSection";
import IMAGES from "constants/images";
import { Icon } from "@iconify/react";
import VendorSidebar from "inc/VendorSidebar";
import { useNavigate } from "react-router-dom";

const MySubscription = () => {
  const navigate = useNavigate()
  const [showFollowers, setShowFollowers] = useState(false);

  return (
      
     
            <Col lg={12} xl={12}>

                <div className="profile_details_style mb-4 header_profile3">
                  <h3>My Subscription</h3>
                </div>
               
                <div className="profile_details_style mb-3 header_profile2  d-flex  justify-content-between ">
        <div className="d-flex align-items-center">
      <Icon icon="mdi:arrow-left" style={{fontSize: "24px"}} className="me-4" onClick={() => navigate("/vendor/my-profile")}/>
      <h3 className="mb-0">My Subscription</h3>
      </div>
      </div>
                <Row>
                  <Col lg={6}>
                    <div className="table_card pricing_Box mb-5">
                      <Card className="bg-white">
                        <Card.Body>
                          <div className="pricing_header">
                            <div
                              className="circle_img"
                              style={{ backgroundColor: "#CFE3F8" }}
                            >
                              <Card.Img
                                variant="top"
                                src={IMAGES.Circle_IMG1}
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  objectFit: "contain",
                                  borderRadius: "0",
                                }}
                              />
                            </div>
                            <div className="flex-grow-1">
                              <h4 className="fw-bold mb-0">Basic</h4>
                            </div>
                          </div>

                          <p className="pricingPara text-muted">
                            Collaborate and optimize your team processes
                          </p>

                          <h2 className="fw-bold text-dark">
                            Free{" "}
                            <span className="fs-5" style={{ color: "#6E6E73" }}>
                              for 7 days
                            </span>
                          </h2>
                          <h6 className="fw-bold mt-3">What's included</h6>
                          <ul className="list-unstyled text-start">
                            <li className="d-flex align-items-center">
                              <Icon
                                color="#0071E3"
                                icon="icon-park-solid:check-one"
                                fontSize={24}
                              />
                              <span className="ms-2">
                                Basic Product Listing
                              </span>
                            </li>
                            <li className="d-flex align-items-center">
                              <Icon
                                color="#0071E3"
                                icon="icon-park-solid:check-one"
                                fontSize={24}
                              />
                              <span className="ms-2">Basic Analytics</span>
                            </li>
                            <li className="d-flex align-items-center">
                              <Icon
                                color="#0071E3"
                                icon="icon-park-solid:check-one"
                                fontSize={24}
                              />
                              <span className="ms-2">Standard Branding</span>
                            </li>
                            <li className="d-flex align-items-center">
                              <Icon
                                color="#0071E3"
                                icon="icon-park-solid:check-one"
                                fontSize={24}
                              />
                              <span className="ms-2">Review Response</span>
                            </li>
                          </ul>
                          <div className="mt-4 ">
                            <Button
                              variant="info"
                              className=" px-4 rounded-pill"
                            >
                              Try For Free
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="table_card pricing_Box active_Box mb-5">
                      <Card className="bg-white">
                        <Card.Body>
                          <div className="pricing_header">
                            <div
                              className="circle_img"
                              style={{ backgroundColor: "#CFE3F8" }}
                            >
                              <Card.Img
                                variant="top"
                                src={IMAGES.Circle_IMG1}
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  objectFit: "contain",
                                  borderRadius: "0",
                                }}
                              />
                            </div>
                            <div className="flex-grow-1">
                              <h4 className="fw-bold mb-0">Standard</h4>
                            </div>
                          </div>

                          <p className="pricingPara text-muted">
                            Collaborate and optimize your team processes
                          </p>

                          <h2 className="fw-bold text-dark">
                            $12{" "}
                            <span className="fs-5" style={{ color: "#6E6E73" }}>
                              /monthly
                            </span>
                          </h2>
                          <h6 className="fw-bold mt-3">What's included</h6>
                          <ul className="list-unstyled text-start">
                            <li className="d-flex align-items-center">
                              <Icon
                                color="#0071E3"
                                icon="icon-park-solid:check-one"
                                fontSize={24}
                              />
                              <span className="ms-2">Enhanced branding</span>
                            </li>
                            <li className="d-flex align-items-center">
                              <Icon
                                color="#0071E3"
                                icon="icon-park-solid:check-one"
                                fontSize={24}
                              />
                              <span className="ms-2">Advanced analytics.</span>
                            </li>
                            <li className="d-flex align-items-center">
                              <Icon
                                color="#0071E3"
                                icon="icon-park-solid:check-one"
                                fontSize={24}
                              />
                              <span className="ms-2">Review management.</span>
                            </li>
                            <li className="d-flex align-items-center">
                              <Icon
                                color="#0071E3"
                                icon="icon-park-solid:check-one"
                                fontSize={24}
                              />
                              <span className="ms-2">Dispute management</span>
                            </li>
                          </ul>
                          <div className="mt-4 d-flex justify-content-between align-items-center">
                            <Button
                              variant="info"
                              className="px-4 rounded-pill"
                            >
                              Renew
                            </Button>
                            <span className="text-muted fs-14">
                              Expiry Jan 02, 2025
                            </span>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="centerbtn">
                      <Button
                        variant="outline-info"
                        className="iconFlex border-radius-100 justify-content-center"
                      >
                        Cancel My Subscription
                      </Button>
                    </div>
                  </Col>
                </Row>
                </Col>
  );
};

export default MySubscription;
